__turbopack_context__.v({
  "actionInfoPromo": "PromotionSummary-module-scss-module__opH2dG__actionInfoPromo",
  "calendarIcon": "PromotionSummary-module-scss-module__opH2dG__calendarIcon",
  "code": "PromotionSummary-module-scss-module__opH2dG__code",
  "item": "PromotionSummary-module-scss-module__opH2dG__item",
  "name": "PromotionSummary-module-scss-module__opH2dG__name",
  "promotionSummary": "PromotionSummary-module-scss-module__opH2dG__promotionSummary",
  "value": "PromotionSummary-module-scss-module__opH2dG__value",
});
